import React from "react";
import styled from "styled-components";
import { color, font } from "../../theme/tokens";
import { Band, BandInner } from "./HeroElements";

const Quote = styled.blockquote`
  font-family: ${font.display};
  font-size: 42px;
  font-weight: 300;
  line-height: 1.28;
  letter-spacing: -0.01em;
  color: ${color.inkStrong};
  margin: 0;
  max-width: 22ch;

  @media screen and (max-width: 1000px) {
    font-size: 34px;
    max-width: none;
  }

  @media screen and (max-width: 600px) {
    font-size: 26px;
  }
`;

const Attribution = styled.footer`
  font-family: ${font.body};
  margin-top: 36px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: ${color.inkMuted};
`;

const Rule = styled.div`
  width: 64px;
  height: 3px;
  background: ${color.clay};
  margin-bottom: 40px;
`;

export default function PullQuote() {
  return (
    <Band $tone="deep">
      <BandInner>
        <Rule />
        {/* Unattributed on purpose: this is the firm's position, not a quote
            from a named partner. Swap in a real, approved quote here if you
            want a byline under it. */}
        <Quote>
          The best consumer brands are not built in a funding cycle. They are
          built over a decade, by founders who refuse to compromise on the
          product.
        </Quote>
        <Attribution>How we think about it</Attribution>
      </BandInner>
    </Band>
  );
}
